/**
 * Luhn algorithm validator for card number validation.
 *
 * Standard implementation: double every second digit from right,
 * sum digits, check if total mod 10 === 0.
 *
 * Requirements: 10.1
 */
export const LuhnValidator = {
  /**
   * Returns true if the digit string passes the Luhn check.
   * Only accepts strings composed entirely of digits.
   */
  isValid(cardNumber: string): boolean {
    if (!/^\d+$/.test(cardNumber) || cardNumber.length === 0) {
      return false;
    }

    let sum = 0;
    const len = cardNumber.length;
    const parity = len % 2;

    for (let i = 0; i < len; i++) {
      let digit = parseInt(cardNumber[i], 10);

      if (i % 2 === parity) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
    }

    return sum % 10 === 0;
  },
};
